import React from "react";

export default function PoweredBy() {
  return (
    <a
      href="https://www.beyondmeasure.global"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="powered-by-beyond-measure"
      title="Powered by Beyond Measure"
      style={{
        position: "fixed",
        bottom: 8,
        right: 8,
        zIndex: 30,
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 9px 4px 6px",
        background: "rgba(15,15,18,.88)",
        color: "#e9e7e0",
        borderRadius: 999,
        textDecoration: "none",
        boxShadow: "0 4px 12px rgba(0,0,0,.22)",
        backdropFilter: "blur(8px)",
        border: "1px solid rgba(255,255,255,.06)",
        fontSize: 9.5,
        fontWeight: 600,
        letterSpacing: ".02em",
        transition: "transform .15s ease, box-shadow .15s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow = "0 10px 24px rgba(0,0,0,.32)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,.25)";
      }}
    >
      <img
        src="/brand/beyond-measure.png"
        alt="Beyond Measure"
        width="16"
        height="16"
        style={{ display: "block", borderRadius: 4 }}
      />
      <span>
        <span style={{ opacity: 0.65, fontWeight: 500 }}>Powered by </span>
        <span style={{ color: "#5ae0c8" }}>Beyond Measure</span>
      </span>
    </a>
  );
}
